import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  getTemplatesByCityId,
  NewPermitTemplateListPage as PermitTemplateListPage,
} from '@/features/city-clerk/permit-template'
import { PLACEHOLDER_IDS } from '@/components/layout/sidebar/constants'
import { queryKeys } from '@/lib/query-keys'

export const Route = createFileRoute('/(app)/city-clerk/$id/permit-template/')({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.permitTemplatesView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  loader: ({ context: { queryClient }, params: { id } }) => {
    if (!id || id === PLACEHOLDER_IDS.NO_CITY_CLERK) return
    return queryClient.fetchQuery({
      queryKey: queryKeys.templates.list(id, 1, 29),
      queryFn: () => getTemplatesByCityId(id, 1, 29),
    })
  },
  component: PermitTemplateListPage,
})
